module.exports = __webpack_public_path__ + "6f671e2b9feecfa8bcafc877966f5d78.jpg";